"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiringProcessColumnsSendMessageModal = HiringProcessColumnsSendMessageModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const Api = __importStar(require("@src/api"));
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_ga_1 = __importDefault(require("@src/helpers/react-ga"));
const gtm_1 = __importDefault(require("@src/helpers/gtm"));
const app_context_1 = require("@src/context/app-context");
const HiringProcessColumnsSendMessageModalStep_1 = require("./HiringProcessColumnsSendMessageModalStep");
const getInitialStepState = () => ({
    new: {},
    interview: {},
    hired: {},
    rejected: {},
});
const StyledInfoAlert = (0, styled_components_1.default)(antd_1.Alert) `
	align-items: start;
	background-color: #e6f7ff;
	border: 1px solid #91d5ff;
	color: rgba(0, 0, 0, 0.85);

	.anticon {
		color: #1890ff;
		margin-top: 3px;
	}
`;
function HiringProcessColumnsSendMessageModal({ isOpen, onClose, setApplications, applications }) {
    const [stepsState, setStepsState] = react_1.default.useState(getInitialStepState());
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const [currentStep, setCurrentStep] = react_1.default.useState(0);
    const intl = (0, react_intl_1.useIntl)();
    const AppContext = (0, app_context_1.useAppContextProvider)();
    const [form] = antd_1.Form.useForm();
    const applicationsCount = (0, flatten_1.default)(Object.values(applications)).length;
    react_1.default.useEffect(() => {
        const newApplications = Object.keys(applications).reduce((acc, stage) => {
            if (applications[stage].length > 0) {
                acc[stage] = {
                    applications: applications[stage],
                    message: null,
                };
            }
            return acc;
        }, {});
        setStepsState(newApplications);
        setIsInitialized(true);
    }, [applications]);
    const modalTitleMap = {
        new: intl.formatMessage({ id: 'offer_application.stage.new' }),
        viewed: intl.formatMessage({ id: 'offer_application.stage.new' }),
        preselection: intl.formatMessage({ id: 'offer_application.stage.preselection' }),
        interview: intl.formatMessage({ id: 'offer_application.stage.interview' }),
        rejected: intl.formatMessage({ id: 'offer_application.stage.rejected' }),
        hired: intl.formatMessage({ id: 'offer_application.stage.hired' }),
    };
    const nonEmptyApplicationGroup = Object.keys(applications).filter(stage => applications[stage].length > 0);
    const isLastStep = nonEmptyApplicationGroup.length === currentStep + 1;
    const okText = isLastStep
        ? intl.formatMessage({
            id: 'general.buttons.send',
        })
        : intl.formatMessage({
            id: 'general.buttons.next',
        });
    const currentStepStage = nonEmptyApplicationGroup[currentStep];
    const sendMessages = async () => {
        let requestData;
        try {
            const formData = await form.validateFields();
            requestData = Object.entries(stepsState).map(([stage, state]) => {
                return {
                    ...formData[stage],
                    applications: state.applications.map(app => ({
                        id: app.id,
                        ...(formData[stage].scheduleInterview && {
                            ...formData[stage].applications[app.id],
                        }),
                    })),
                };
            });
        }
        catch (error) {
            // change step if error is in other step
            if (!error.errorFields.some(e => e.name[0] === currentStepStage)) {
                for (let i = 0; i < nonEmptyApplicationGroup.length; i += 1) {
                    if (error.errorFields.some(e => e.name[0] === nonEmptyApplicationGroup[i])) {
                        setCurrentStep(i);
                        break;
                    }
                }
            }
        }
        if (requestData) {
            try {
                setIsLoading(true);
                setApplications(stepsState);
                await Api.OfferApplication.sendGroupedMessage(requestData, AppContext.value.language);
                onClose();
                react_ga_1.default.event({
                    category: 'Company',
                    action: 'Group message sent',
                    label: 'Admin - Applicants',
                });
                gtm_1.default.dataLayer({
                    event: 'company_group_message_sent',
                    category: 'company',
                });
                antd_1.notification.success({
                    message: intl.formatMessage({
                        id: 'admin.hiring_process.send_message.successfully_sent_notification.title',
                    }),
                    description: intl.formatMessage({
                        id: 'admin.hiring_process.send_message.successfully_sent_notification.message',
                    }, { count: applicationsCount }),
                });
            }
            catch (err) {
                console.error(err);
            }
            finally {
                setIsLoading(false);
            }
        }
    };
    if (!isInitialized) {
        return null;
    }
    const formInitialValues = {
        [types_1.EOfferApplicationStage.interview]: {
            scheduleInterview: false,
            interviewType: types_1.EInterviewType.video_call,
            includeVideoCallUrl: true,
        },
    };
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { zIndex: 2150000000, title: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.send_message.title", values: { count: applicationsCount } }), visible: isOpen, onOk: () => {
            if (!isLastStep) {
                setCurrentStep(currentStep + 1);
            }
            else {
                sendMessages();
            }
        }, width: 720, confirmLoading: isLoading, onCancel: () => onClose(), cancelText: intl.formatMessage({ id: 'admin.hiring_process.send_message.do_not_send' }), okText: okText, children: [nonEmptyApplicationGroup.length > 1 && ((0, jsx_runtime_1.jsx)(elements_1.Steps, { current: currentStep, onChange: current => setCurrentStep(current), type: "navigation", size: "small", className: "m-b-l", children: nonEmptyApplicationGroup.map(stage => ((0, jsx_runtime_1.jsx)(elements_1.Steps.Step, { description: modalTitleMap[stage] }, modalTitleMap[stage]))) })), applicationsCount > 1 && ((0, jsx_runtime_1.jsx)(StyledInfoAlert, { className: "m-b-l", message: intl.formatMessage({ id: 'admin.hiring_process.send_message.info_group_message' }), type: "info", showIcon: true })), (0, jsx_runtime_1.jsx)(antd_1.Form, { form: form, initialValues: formInitialValues, children: nonEmptyApplicationGroup.map(stage => ((0, jsx_runtime_1.jsx)("div", { className: stage === currentStepStage ? undefined : 'hidden', children: (0, jsx_runtime_1.jsx)(HiringProcessColumnsSendMessageModalStep_1.HiringProcessColumnsSendMessageModalStep, { form: form, type: stage, stepState: stepsState[stage] }) }, `application-send-modal-step-${stage}`))) })] }));
}
